import { META_PIXEL_ID, GOOGLE_TAG_ID } from "@/config/tracking";

export const CONSENT_KEY = "cs_cookie_consent"; // "accepted" = tecnici + marketing, "rejected" = solo necessari
const FB_EVENTS = { page_view: "PageView", view_content: "ViewContent", whatsapp_click: "Contact", generate_lead: "Lead" };
let loaded = false;

export const getConsent = () => localStorage.getItem(CONSENT_KEY);
export const hasMarketingConsent = () => getConsent() === "accepted";
export const openCookieBanner = () => window.dispatchEvent(new Event("cs-open-cookie-banner"));

// Carica Meta Pixel / Google Tag solo con consenso esplicito e ID valorizzati.
export const loadPixels = () => {
  if (loaded || !hasMarketingConsent()) return;
  loaded = true;
  if (META_PIXEL_ID) {
    window.fbq = window.fbq || function () { (window.fbq.q = window.fbq.q || []).push(arguments); };
    window._fbq = window.fbq;
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
    window.fbq("init", META_PIXEL_ID);
  }
  if (GOOGLE_TAG_ID) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_ID}`;
    document.head.appendChild(s);
    window.gtag("js", new Date());
    window.gtag("config", GOOGLE_TAG_ID, { send_page_view: false }); // page_view inviata manualmente a ogni rotta
  }
};

export const track = (event, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (META_PIXEL_ID && window.fbq) window.fbq("track", FB_EVENTS[event] || event, params);
  if (GOOGLE_TAG_ID && window.gtag) window.gtag("event", event, params);
};

// Revoca: rimuove i cookie di Meta/Google e ricarica per scaricare gli script.
export const clearMarketingCookies = () => {
  const host = window.location.hostname;
  const domains = ["", host, `.${host}`, `.${host.split(".").slice(-2).join(".")}`];
  document.cookie.split(";").forEach((c) => {
    const name = c.split("=")[0].trim();
    if (!/^(_fbp|_fbc|_ga|_gid|_gat|_gcl)/.test(name)) return;
    domains.forEach((d) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ""}`;
    });
  });
};

export const getAttribution = () => {
  const q = new URLSearchParams(window.location.search);
  const pick = (k) => (q.get(k) || "").slice(0, 200);
  return {
    utm_source: pick("utm_source"), utm_medium: pick("utm_medium"), utm_campaign: pick("utm_campaign"),
    utm_content: pick("utm_content"), utm_term: pick("utm_term"), gclid: pick("gclid"), fbclid: pick("fbclid"),
    referrer: document.referrer.slice(0, 300), landing_url: window.location.href.slice(0, 500),
  };
};
